import styled from 'styled-components';
import { SEMANTIC_COLORS } from '@/constant/unit/color';
export const S = {
    Layout: styled.div `
    display: flex;

    ${(props) => (props.customStyle ? props.customStyle : '')};

    & > svg {
      flex-shrink: 0;
      margin: 2px 0 0 -6px;
    }

    font-size: 16px;
    font-weight: 500;
    line-height: 23px;

    color: ${SEMANTIC_COLORS.SECONDARY_TEXT};
  `,
};
